var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdblock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9368 21.9616C58.8747 9.84071 85.688 17.0446 97.7765 38.0386C109.865 59.0326 102.68 85.9177 81.7425 98.0386C60.8046 110.159 33.9913 102.956 21.9028 81.9616C9.81433 60.9676 16.9989 34.0825 37.9368 21.9616ZM43.3623 31.3839C27.6108 40.5024 22.2056 60.7281 31.2997 76.5218C40.3939 92.3158 60.5658 97.735 76.3172 88.6166C92.0687 79.4981 97.4736 59.2725 88.3794 43.4786C79.2853 27.6849 59.1138 22.2655 43.3623 31.3839Z",
    fill: "#FFC61B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9368 21.9616C58.8747 9.84071 85.688 17.0446 97.7765 38.0386C109.865 59.0326 102.68 85.9177 81.7425 98.0386C60.8046 110.159 33.9913 102.956 21.9028 81.9616C9.81433 60.9676 16.9989 34.0825 37.9368 21.9616ZM43.3623 31.3839C27.6108 40.5024 22.2056 60.7281 31.2997 76.5218C40.3939 92.3158 60.5658 97.735 76.3172 88.6166C92.0687 79.4981 97.4736 59.2725 88.3794 43.4786C79.2853 27.6849 59.1138 22.2655 43.3623 31.3839Z",
    fill: "url(#paint0_linear_9141_2538)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9679 13.2846C76.3281 12.3511 77.3748 11.8872 78.3057 12.2483C85.6814 15.1096 92.4348 19.693 97.9012 25.8215C100.208 28.408 102.285 31.2681 104.081 34.3881C109.937 44.5578 111.915 55.9171 110.476 66.7317C110.344 67.7238 109.435 68.4207 108.445 68.2883C107.456 68.1559 106.761 67.2443 106.893 66.2522C108.231 56.2018 106.393 45.6523 100.951 36.2004C99.2794 33.2977 97.3493 30.6397 95.2067 28.2378L95.2067 28.2378C90.1311 22.5474 83.8582 18.2888 77.0014 15.6287C76.0704 15.2675 75.6077 14.218 75.9679 13.2846Z",
    fill: "#7F39FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.113 67.1335C106.393 46.3989 94.7611 26.1896 75.2153 18.6621L59.3163 60.1698L103.113 67.1335Z",
    fill: "#7F39FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9141_2538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.985 59.9176C97.4705 55.5842 100.035 45.9869 95.7135 38.4813C91.3917 30.9758 81.82 28.4042 74.3345 32.7375C66.849 37.0709 64.2843 46.6682 68.606 54.1738C72.9278 61.6793 82.4995 64.2509 89.985 59.9176Z",
    fill: "url(#paint1_radial_9141_2538)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7356 67.0239L28.5808 68.8502C27.7242 69.346 27.0975 70.1642 26.8414 71.1233C26.5853 72.0823 26.7182 73.1024 27.2145 73.9642C28.4747 76.1528 30.1319 79.0309 31.3921 81.2195C31.8865 82.0781 32.703 82.7068 33.6593 82.9639C34.6157 83.2211 35.6358 83.0859 36.4923 82.5901C38.0758 81.6734 39.6471 80.7638 39.6471 80.7638L31.7356 67.0239Z",
    fill: "url(#paint2_linear_9141_2538)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2186 19.2996C67.2189 30.8101 61.5049 40.338 51.5322 46.7621L36.2793 55.592C31.2443 58.5067 29.5188 64.964 32.4279 70.016C33.8563 72.4969 35.4056 75.1875 36.8341 77.6683C39.7431 82.7204 46.181 84.4471 51.216 81.5323C58.2166 77.4797 66.696 72.571 66.696 72.571C76.2422 66.2829 87.851 67.5186 99.588 70.3051L70.2186 19.2996Z",
    fill: "url(#paint3_linear_9141_2538)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9407 16.5971C74.191 15.2952 72.5276 14.8453 71.2256 15.599C69.9272 16.3507 69.4806 18.022 70.2303 19.3239L99.2185 69.6676C99.9703 70.9731 101.635 71.4174 102.933 70.6657C104.235 69.912 104.681 68.2463 103.929 66.9408L74.9407 16.5971Z",
    fill: "url(#paint4_linear_9141_2538)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9042 75.8537L52.2736 80.6667C52.2736 80.6667 63.832 93.8753 67.9 98.5265C68.6991 99.4382 70.0496 99.6207 71.0617 98.948C71.0833 98.9355 71.1066 98.9172 71.1318 98.9026C72.1887 98.1992 72.5287 96.8017 71.9116 95.6883C68.9335 90.3242 60.9042 75.8537 60.9042 75.8537Z",
    fill: "url(#paint5_linear_9141_2538)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1454 81.8432L36.2476 24.793L27.5233 33.5407L84.421 90.5909L93.1454 81.8432Z",
    fill: "#FFC61B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1454 81.8432L36.2476 24.793L27.5233 33.5407L84.421 90.5909L93.1454 81.8432Z",
    fill: "url(#paint6_linear_9141_2538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9141_2538",
    x: 22.714,
    y: 15.2334,
    width: 85.5803,
    height: 92.1194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9141_2538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9141_2538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9141_2538",
    x1: 60,
    y1: 104.68,
    x2: 60,
    y2: 44.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9141_2538",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.5 33.9999) rotate(91.1935) scale(24.0052 23.9696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9050FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9141_2538",
    x1: 37.5,
    y1: 82.4999,
    x2: 27,
    y2: 65.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9141_2538",
    x1: 56.2758,
    y1: 43.2494,
    x2: 97.3309,
    y2: 93.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E4BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9141_2538",
    x1: 83,
    y1: 47.4999,
    x2: 90.5,
    y2: 42.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A976FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9141_2538",
    x1: 55,
    y1: 81.9999,
    x2: 62,
    y2: 76.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0304692,
    stopColor: "#AB79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9141_2538",
    x1: 63,
    y1: 103.477,
    x2: 63,
    y2: 51.7383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D38F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B800"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdblock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adblock.90116728572574db2c3713cfdf8e8433.svg";